import React from 'react';
import { Spin } from 'antd';
import { Layout } from 'antd';
import { primaryShades } from '../theme/theme';

const { Content } = Layout;
const BACKGROUND_COLOR = primaryShades.primary100;

const CenteredLoader = ({ backgroundColor = BACKGROUND_COLOR }) => {
    return (
        <Content
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: backgroundColor,
            }}
        >
            <Spin size="large" />
        </Content>
    );
};

export default CenteredLoader;